import React, { useState, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'antd';
import {
  spawnFormatter,
  spawnAccessCheck,
  isAllocationValuePercent,
  checkSpawnEdit,
} from '../../utils';
import RecurringFooter from './Footer';
import {
  GrantsTable,
  LinkWrapper,
  GrantNameField,
  ExpandableLabel,
  AlertWrap,
  TableEditBtnWrapper
} from '../../style';
import { getPrimaryAccount } from '../../../../../../utils/sessionUtil';
import { ShowMoreButton } from '../../../../../../CommonComponents/CTA/Buttons';
import RecurringCard from './RecurringCard';
import formatter from '../../../../../../utils/formatter';
import { CardContainer } from '../RenderCard/style';
import ErrorPopup from '../../../../../../CommonComponents/ErrorPopup/ErrorPopup';
import { checkCSRBusinessFunction } from '../../../../../../CSR/utils/CommonUtils';
import { BUSINESS_FUNCTION } from '../../../../../../CSR/utils/csrBusinessFunctionMapper';
import {
  AlertContent,
  Types,
} from '../../../../../../CommonComponents/ContentMessages';
import { recordError } from '../../../../../../utils/commonUtil';
import { CapsuleButton } from '../../../../../../CommonComponents/Commons/commonComponents';
import { replaceSelect } from "../../../../../../utils/replacer";

export const CustomExpandIcon = (expand) => {
  let btnFlag;
  if (!expand.expanded) btnFlag = false;
  else btnFlag = true;
  return (
    <ShowMoreButton
      data-test="recurring-table-show-more"
      reverse={btnFlag}
      buttonHandle={(e) => expand.onExpand(expand.record, e)}
    />
  );
};

const onExpand = (expanded, record) => {
  // console.log("onExpand", expanded, record);
};

export const showMoreRender = (data) => (
  <Row>
    <Col lg={6}>
      <ExpandableLabel header>Investment Options</ExpandableLabel>
      {data.grantAllocation &&
        data.grantAllocation.map((item) => (
          <ExpandableLabel key={item.poolId}>{replaceSelect(item.option)}</ExpandableLabel>
        ))}
    </Col>
    <Col lg={6}>
      <ExpandableLabel header>
        {isAllocationValuePercent(data.allocationType)
          ? 'Grant Percentage'
          : 'Grant Amount'}
      </ExpandableLabel>
      {data.grantAllocation &&
        data.grantAllocation.map((item) => (
          <ExpandableLabel key={item.poolId}>
            {isAllocationValuePercent(data.allocationType)
              ? `${formatter({
                  value: item.value,
                  fieldSuffix: 'Percentage',
                })}`
              : `${formatter({ value: item.value, fieldSuffix: 'Dollars' })}`}
          </ExpandableLabel>
        ))}
    </Col>
    {!data.grantAllocation ||
      (!data.grantAllocation.length && (
        <Col>
          <ExpandableLabel>No Investment</ExpandableLabel>
        </Col>
      ))}
  </Row>
);

const RecurringTable = (props) => {
  const {
    edit,
    spawns,
    cancelApi,
    addGrantApiCall,
    viewHandle,
    scheduleStatus,
    csrBusinessFunction,
  } = props;
  const { role } = getPrimaryAccount();
  const [spawnsCollection, setSpawnCollection] = useState(
    spawnFormatter(spawns)
  );
  const [paymentFlag, setPaymentFlag] = useState(false);
  const [cancelPaymentFlag, setCancelPaymentFlag] = useState(true);
  const [_currentSpawnId, setCurrentSpawn] = useState(false);
  const [_currentSpawnStatus, setSpawnStatus] = useState(false);
  const [contentType, setPopUpContent] = useState(false);
  const [cancelPopUp, setCancelPopup] = useState(false);
  const [addGrantPopUp, setAddGrantPopUp] = useState(false);
  const WarningContents = {
    allSpawns: 'Are you sure you want to cancel all remaining payments?',
    spawn: 'Are you sure you want to cancel this grant payment?',
    add:
      'The grant payment added to the schedule will follow details of the previous payment in the schedule.',
  };

  useEffect(() => {
    setSpawnCollection(spawnFormatter(spawns));
  }, [spawns]);

  const hidePaymentHandle = useCallback(() => {
    let filteredArray = spawnsCollection.filter(
      ({ status }) =>
        status.toUpperCase() !== 'COMPLETE' &&
        status.toUpperCase() !== 'CANCELLED' &&
        status.toUpperCase() !== 'PAYMENT COMPLETED'
    );
    setSpawnCollection(filteredArray);
    setPaymentFlag(true);
  }, [spawnsCollection]);

  const individualCancelHandler = (record, type) => {
    try {
      if (record) {
        let _spawnId = record && record.spawnId;
        let _spawnStatus = record && record.status;
        setCurrentSpawn(_spawnId);
        setSpawnStatus(_spawnStatus);
      }
      if (type) {
        setPopUpContent(type);
      } else {
        setCurrentSpawn(false);
        setPopUpContent('allSpawns');
      }

      setCancelPopup(!cancelPopUp);
    } catch (error) {
      recordError(error);
    }
  };

  const showPaymentHandle = useCallback(() => {
    setSpawnCollection(spawnFormatter(spawns));
    setPaymentFlag(false);
  }, [spawns]);

  const columnConfig = [
    {
      title: 'Grant Name',
      dataIndex: 'grantName',
      key: 'grantName',
      render: (value, record) => <GrantNameField>{value}</GrantNameField>,
    },
    {
      title: 'Grant Amount',
      dataIndex: 'amount',
      key: 'amount',
      render: (value) =>
        value ? (
          <GrantNameField NoBorder>
            {formatter({ value, fieldSuffix: 'Dollars' })}
          </GrantNameField>
        ) : (
          <div>&mdash;</div>
        ),
    },
    {
      title: 'Scheduled Issue Date',
      dataIndex: 'scheduledDate',
      key: 'scheduledDate',
      render: (value) =>
        value ? (
          <GrantNameField NoBorder>{value}</GrantNameField>
        ) : (
          <div>&mdash;</div>
        ),
    },
    {
      title: 'Issue Date',
      dataIndex: 'issueDate',
      key: 'issueDate',
      render: (value) =>
        value ? (
          <GrantNameField NoBorder>{value}</GrantNameField>
        ) : (
          <div>&mdash;</div>
        ),
    },
    {
      title: 'Check Number',
      dataIndex: 'checkNumber',
      key: 'checkNumber',
      render: (value) =>
        value ? (
          <GrantNameField NoBorder>{value}</GrantNameField>
        ) : (
          <div>&mdash;</div>
        ),
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      render: (value) =>
        value ? (
          <GrantNameField NoBorder>{value}</GrantNameField>
        ) : (
          <div>&mdash;</div>
        ),
    },
    {
      title: '',
      dataIndex: 'status',
      key: 'status',
      render: (value, record) =>
        edit &&
        scheduleStatus === 'Active' &&
        checkSpawnEdit(record.status,scheduleStatus,csrBusinessFunction) ? (
          <TableEditBtnWrapper>
            <CapsuleButton
              text="View & Edit"
              onClick={() => viewHandle({ spawnId: record.spawnId, edit: true })}
              whiteBackground={true}
              alt = "View and Edit"
            />
          </TableEditBtnWrapper>
        ) : (
          <TableEditBtnWrapper>
            <CapsuleButton
              text="View"
              onClick={() => viewHandle({ spawnId: record.spawnId, edit: false })}
              whiteBackground={true}
              alt  = "view button"
            />
          </TableEditBtnWrapper>
        ),
    },
    {
      title: '',
      dataIndex: 'status',
      key: 'status',
      render: (value, record, index) =>
        spawnAccessCheck(record.status) && edit ? (
          <LinkWrapper
            onClick={() => individualCancelHandler(record, 'spawn')}
            className={
              checkCSRBusinessFunction(
                BUSINESS_FUNCTION[
                  'DONOR_PORTAL_EDIT_RECURRING_GRANT_SCHEDULE_FULL_ACCESS'
                ],
                csrBusinessFunction
              )
                ? 'disable-link-click'
                : ''
            }
          >
            Cancel
          </LinkWrapper>
        ) : (
          ''
        ),
    },
    {
      title: '',
      dataIndex: 'status',
      key: 'status',
      render: () => <div />,
    },
  ];

  const addGrantApiCallPopup = () => setAddGrantPopUp(true);

  return (
    <>

      <>
        <ErrorPopup
          title={
            <AlertContent
              page={'Edit Grant'}
              type={[Types.PAGE_ALERTS]}
              keyProperty={
                contentType === 'allSpawns'
                  ? 'Cancel All Payment Edit Grant'
                  : 'Cancel Payment Edit Grant'
              }
              property={'field_header'}
              html={true}
              defaultMessage={'Cancel'}
            />
          }
          show={cancelPopUp}
          primaryCta={() => {
            setCancelPopup(false);
            _currentSpawnId
              ? cancelApi(_currentSpawnId, 'single', _currentSpawnStatus)
              : cancelApi(_currentSpawnId, 'all');
          }}
          secondaryCta={() => individualCancelHandler()}
          secondaryCtaLabel={
            <AlertContent
              page={'Edit Grant'}
              type={[Types.PAGE_ALERTS]}
              keyProperty={
                contentType === 'allSpawns'
                  ? 'Cancel All Payment Edit Grant'
                  : 'Cancel Payment Edit Grant'
              }
              property={'field_alert_button2_text'}
              html={true}
              defaultMessage={'CONTINUE'}
            />
          }
          primaryCtaLabel={
            <AlertContent
              page={'Edit Grant'}
              type={[Types.PAGE_ALERTS]}
              keyProperty={
                contentType === 'allSpawns'
                  ? 'Cancel All Payment Edit Grant'
                  : 'Cancel Payment Edit Grant'
              }
              property={'field_alert_button1_text'}
              html={true}
              defaultMessage={'No, take me back'}
            />
          }
        >
          <AlertWrap>
            <AlertContent
              page={'Edit Grant'}
              type={[Types.PAGE_ALERTS]}
              keyProperty={
                contentType === 'allSpawns'
                  ? 'Cancel All Payment Edit Grant'
                  : 'Cancel Payment Edit Grant'
              }
              property={'field_description'}
              html={true}
              defaultMessage={WarningContents[contentType]}
            />
          </AlertWrap>
        </ErrorPopup>
      </>
      <>
        <ErrorPopup
          title={
            <AlertContent
              page={'Edit Grant'}
              type={[Types.PAGE_ALERTS]}
              keyProperty={'Add Grant'}
              property={'field_header'}
              html={true}
              defaultMessage={'Add Grant'}
            />
          }
          primaryCtaLabel={
            <AlertContent
              page={'Edit Grant'}
              type={[Types.PAGE_ALERTS]}
              keyProperty={'Add Grant'}
              property={'field_alert_button1_text'}
              html={true}
              defaultMessage={'Ok'}
            />
          }
          show={addGrantPopUp}
          primaryCta={() => {
            setAddGrantPopUp(false);
            addGrantApiCall();
          }}
        >
          <AlertWrap>
            <AlertContent
              page={'Edit Grant'}
              type={[Types.PAGE_ALERTS]}
              keyProperty={'Add Grant'}
              property={'field_description'}
              html={true}
              defaultMessage={
                'The grant payment added to the schedule will follow details of the previous payment in the schedule.'
              }
            />
          </AlertWrap>
        </ErrorPopup>
      </>
      <Row>
        <Col lg={24} md={24} sm={0} xs={0}>
          <GrantsTable
            ColorLess
            dataSource={spawnsCollection}
            expandedRowRender={(record) => record && showMoreRender(record)}
            columns={columnConfig}
            pagination={false}
            onExpand={onExpand}
            expandIcon={CustomExpandIcon}
            expandIconColumnIndex={8}
            expandIconAsCell={false}
          />
        </Col>
      </Row>

      <>
        <Row>
          <Col lg={0} md={0} sm={24} xs={24}>
            {spawnsCollection &&
              spawnsCollection.map((data, index) => (
                <CardContainer noPaddingBottom key={data.spawnId} index={1}>
                  <RecurringCard
                    data={data}
                    indexKey={index}
                    component="RecurringCard"
                    viewHandle={viewHandle}
                    cancelApi={cancelApi}
                    edit={edit}
                    scheduleStatus={scheduleStatus}
                  />
                </CardContainer>
              ))}
          </Col>
        </Row>
      </>

      {(scheduleStatus === 'Active' || scheduleStatus === 'Entered') && (
        <RecurringFooter
          role={role && role.access}
          paymentFlag={paymentFlag}
          cancelPaymentFlag={cancelPaymentFlag}
          showPaymentHandle={showPaymentHandle}
          hidePaymentHandle={hidePaymentHandle}
          cancelPaymentHandle={individualCancelHandler}
          addGrandHandler={addGrantApiCallPopup}
          csrBusinessFunction={csrBusinessFunction}
        />
      )}
    </>
  );
};

RecurringTable.propTypes = {
  edit: PropTypes.bool.isRequired,
  spawns: PropTypes.arrayOf(
    PropTypes.shape({
      allShareallPool: PropTypes.bool,
      allocationType: PropTypes.string,
      amount: PropTypes.string,
      charityDetails: PropTypes.shape({
        charityName: PropTypes.string,
        city: PropTypes.string,
        country: PropTypes.string,
        cryptoIndex: PropTypes.number,
        cypherText: PropTypes.string,
        ein: PropTypes.string,
        foreignState: PropTypes.string,
        line2: PropTypes.string,
        line3: PropTypes.string,
        state: PropTypes.string,
        stateId: PropTypes.number,
        stateType: PropTypes.string,
        streetAddress: PropTypes.string,
        zip: PropTypes.string,
      }),
      checkIssuedDate: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string,
      ]),
      checkIssuedDateStr: PropTypes.string,
      checkNumber: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      dollarbased: PropTypes.bool,
      grantAllocation: PropTypes.shape({
        allShareSpecificPool: PropTypes.bool,
        option: PropTypes.string,
        poolId: PropTypes.number,
        value: PropTypes.string,
      }),
      issueDate: PropTypes.string,
      issueDateStr: PropTypes.string,
      paymentId: PropTypes.number,
      purpose: PropTypes.string,
      recognition: PropTypes.any,
      recordStatus: PropTypes.string,
      scheduleId: PropTypes.number,
      spawnId: PropTypes.number,
      status: PropTypes.string,
    })
  ).isRequired,
  cancelApi: PropTypes.func.isRequired,
  addGrantApiCall: PropTypes.func.isRequired,
  viewHandle: PropTypes.func.isRequired,
  scheduleStatus: PropTypes.string.isRequired,
  csrBusinessFunction: PropTypes.any,
  scheduleId: PropTypes.string.isRequired,
  grantsDetails: PropTypes.shape({
    amount: PropTypes.string,
    frequency: PropTypes.string,
    grantName: PropTypes.string,
    noOfPayments: PropTypes.string,
    startDate: PropTypes.string,
    Table: PropTypes.elementType,
  }),
};

export default RecurringTable;
